export default {
    primary: "Myriad Pro Bold",
    secondary: "Myriad Pro Semibold",
    sizeText: "1.2rem",
    sizeTitle: "1.3rem",
  };
